import './DesktopStyle2.scss';

const DesktopStyle2 = ({ children }: { children: JSX.Element }) => {
  return <>{children}</>;
};

export default DesktopStyle2;
